// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_pa-0";